import type { ActionsObservable } from 'redux-observable';
import type { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/mapTo';
import type { Action } from '../../../state/actions';
import { FETCH_PROJECT_DETAILS_SUCCESS } from '../../../state/entities/actions';
import type { AnalyticEvent } from '../types';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (action$: ActionsObservable<Action>): Observable<AnalyticEvent> =>
	action$.ofType(FETCH_PROJECT_DETAILS_SUCCESS).mapTo({ event: 'view' });
